const useNotificationSetup = () => {};

export default useNotificationSetup;
